import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { DrcButton, DrcTranslate } from '@driscollsinc/driscolls-react-components';
import GridStyles from '../../styles/gridStyles';
import { showLoadingScreenAction, hideLoadingScreenAction, showToast } from '../../actions/actions';
import { connect } from 'react-redux';
import { withOktaAuth } from '@okta/okta-react';
import { downloadFile, makeColumns } from '../../utils/helper';
import MasterDataUtilities from '../../data/MasterDataUtilities';
import { Call } from '@driscollsinc/driscolls-display-rules';
import APIEndPoints from '../../services/api';
import { summaryCNYCol, designColors, summaryPeruCol, summaryChileCol, currencySymbols } from '../../data/constants';
import PrimeReactTable from '../../components/PrimeReactTable';
import NoData from '../../components/NoData';
import { Typography } from '@material-ui/core';
import VerticalAlignBottomIcon from '@material-ui/icons/VerticalAlignBottom';
import { DuAuthenticationUtilities } from '@driscollsinc/driscolls-react-utilities';
const styles = (theme) => ({
    input: {
        '& .MuiOutlinedInput-input': {
            textAlign: 'left'
        }
    },
    gridStyles: GridStyles.styles(theme, '300px', '300px'),
    tableContainer: {
        margin: theme.spacing(3)
    },
    actionContainer: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    icon: {
        marginRight: 5
    }
});

class SummaryReportsCR extends Component {
    state = {
        data: [],
        pageData: [],
        pageNum: 0,
        pageSize: 50,
        totalCount: 0,
        columns: []
    };

    excludingFields = [];
    readOnly = true;
    uniqueKeyField = 'GrowerID';
    widthIsSufficient = window.innerWidth > 955;
    widthIsInSufficient = false;

    componentDidMount() {
        this.props.loadFilteredData(this.loadData.bind(this));
        window.addEventListener('resize', this.updateDataTable);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDataTable);
    }
    updateTableData = (response, hasFrozenColumns = false) => {
        let data = response?.display?.resultSet1 || [];
        let columns = data.length
            ? makeColumns(
                  Object.keys(data[0]),
                  [...this.excludingFields, ...(this.props.filters.ReportType === 'Preliminary' ? ['RemainingPayment'] : [])],
                  null,
                  false,
                  [],
                  [],
                  this.getTemplateColumns(),
                  false,
                  this.getCurrencySymbol()
              )
            : [];
        let start = Math.floor(this.state.pageNum / this.state.pageSize) * this.state.pageSize;
        this.setState({
            data,
            totalCount: data.length || 0,
            pageData: data.slice(start, start + this.state.pageSize) || [],
            columns,
            unfreeze: !hasFrozenColumns
        });
    };
    updateDataTable = (_event, force = false) => {
        if (window.innerWidth > 955 && !this.widthIsSufficient) {
            this.widthIsSufficient = true;
            this.widthIsInSufficient = false;
            this.updateTableData(this.response || [], true);
        } else if (window.innerWidth <= 955 && !this.widthIsInSufficient) {
            this.widthIsInSufficient = true;
            this.widthIsSufficient = false;
            this.updateTableData(this.response || [], false);
        } else if (force) {
            this.updateTableData(this.response || [], true);
        }
    };

    loadData = async () => {
        this.props.showLoadingScreenAction(<DrcTranslate>{'Loading data'}</DrcTranslate>);
        let token = await this.props.oktaAuth.getAccessToken();
        let loggedInUser = DuAuthenticationUtilities.GetEmail(token);
        try {
            var data = await Call(
                {
                    name: 'SummaryReportsCR',
                    url: APIEndPoints.POST_IMPORT_GROWER_SETTLEMENT_REPORT(),
                    method: 'POST',
                    options: {},
                    data: {
                        SearchBy: loggedInUser,
                        ...this.props.filters
                    }
                },
                token
            );
            if (data.errors.length && !data.raw) {
                return this.showError(data.errors[0]);
            }
            this.response = data;
            this.updateDataTable(null, true);
            this.props.hideLoadingScreenAction();
        } catch (error) {
            this.showError(error);
        }
    };

    onPage = (event) => {
        let start = Math.floor(event.first / this.state.pageSize) * this.state.pageSize;
        this.setState({ pageNum: event.first, pageData: this.state.data.slice(start, start + this.state.pageSize) });
    };

    showError = (err, msg) => {
        this.props.hideLoadingScreenAction();
        this.props.showToast(<DrcTranslate>{msg || 'An Error Occurred'}</DrcTranslate>, false);
        console.error('error : ', err);
    };
    exportData = async () => {
        try {
            this.props.showLoadingScreenAction(
                <React.Fragment>
                    <h4 style={{ fontSize: '1.5rem' }}>
                        <DrcTranslate>{'Preparing download'}</DrcTranslate>
                    </h4>
                    <div>
                        <DrcTranslate>{'Your download should start in a few seconds.'}</DrcTranslate>
                    </div>
                </React.Fragment>
            );
            this.props.hideLoadingScreenAction();
            downloadFile(
                `${this.props.reportType.label}_${this.props.poolWeek.value}__${this.props.filters.ReportType}.xlsx`,
                this.state.data,
                this.getTemplateColumns(),
                [...this.excludingFields, ...(this.props.filters.ReportType === 'Preliminary' ? ['Remaining Payment'] : [])],
                this.getCurrencySymbol()
            );
        } catch (err) {
            console.log(err);
        }
    };

    getTemplateColumns = () => {
        switch (this.props.reportType.value) {
            case 'SummaryCNY':
                this.props.filters.ReportType === 'Preliminary'
                    ? (summaryCNYCol['DomesticFreight'] = 'Domestic Freight')
                    : (summaryCNYCol['DomesticFreight'] = 'Total Trans');
                return summaryCNYCol;
            case 'SummaryPeru':
                this.props.filters.ReportType === 'Preliminary'
                    ? (summaryPeruCol['DomesticFreight'] = 'Domestic Freight')
                    : (summaryPeruCol['DomesticFreight'] = 'Total Trans');
                return summaryPeruCol;
            case 'SummaryChile':
                return summaryChileCol;
            default:
                return summaryCNYCol;
        }
    };
    getCurrencySymbol = () => {
        switch (this.props.reportType.value) {
            case 'SummaryCNY':
                return currencySymbols.CNY;
            case 'SummaryPeru':
            case 'SummaryChile':
                return currencySymbols.USD;
            default:
                return currencySymbols.USD;
        }
    };
    render() {
        const { classes } = this.props;
        if (!MasterDataUtilities.Check(this.props.isMasterDataInitialized)) {
            return MasterDataUtilities.Redirect();
        }
        return (
            <div className={classes.tableContainer}>
                <div className={classes.actionContainer}>
                    <Typography variant="h6" noWrap style={{ fontWeight: 'bold', color: designColors.blue, textTransform: 'uppercase' }}>
                        <DrcTranslate>{this.props.reportType.label}</DrcTranslate>
                    </Typography>
                    <DrcButton onClick={this.exportData} style={{ fontWeight: 'bold', color: designColors.blue }} disabled={!this.state.data.length}>
                        <VerticalAlignBottomIcon className={classes.icon} /> <DrcTranslate>{'Export'}</DrcTranslate>
                    </DrcButton>
                </div>
                {!!this.state.data.length ? (
                    <PrimeReactTable
                        paginator={this.state.data.length > 0}
                        currentPage={this.state.pageNum}
                        onPage={this.onPage}
                        columns={this.state.columns}
                        value={this.state.pageData}
                        gridStyles={classes.gridStyles}
                        totalRecords={this.state.totalCount}
                        resultCount={this.state.totalCount}
                        pageSize={this.state.pageSize}
                        uniqueKeyField={this.uniqueKeyField}
                        tableSelectionMode="checkbox"
                        showReport={true}
                        currentPageReportTemplate={'Showing {first} to {last} of {totalRecords} entries'}
                        // frozenWidth={'100px'}
                    />
                ) : (
                    <NoData />
                )}
            </div>
        );
    }
}
const mapStateToProps = ({ masterReducer }) => ({
    isMasterDataInitialized: masterReducer.isInitialized
});
const mapDispatchToProps = (dispatch) => ({
    showToast: (message, type) => dispatch(showToast(message, type)),
    showLoadingScreenAction: (message) => dispatch(showLoadingScreenAction(message)),
    hideLoadingScreenAction: () => dispatch(hideLoadingScreenAction())
});

export default connect(mapStateToProps, mapDispatchToProps)(withOktaAuth(withStyles(styles)(SummaryReportsCR)));
